module.exports = __webpack_public_path__ + "static/img/illus-05.91a74c7.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illus-05.webp
// module id = 106
// module chunks = 0